
    // this file was auto generated by python script
    import AlertTriangle from './AlertTriangle';
    export default AlertTriangle;
    